import { Pipe, PipeTransform } from '@angular/core';
import { camelCase, isArray } from 'lodash-es';

@Pipe({
  name: 'dynamicoptions',
  standalone: false  //NOSONAR
})
export class DynamicOptionsPipe implements PipeTransform {
  transform(value: any, type: any, args: any, actorId?: any): unknown {
    if (isArray(value) && value.length > 0) {
      return value;
    }
    let _value = args[type];
    if (actorId && type === 'Actions') {
      _value = args[type]?.filter((action) => action.actorId === actorId);
    }
    if (!_value) {
      return [];
    }
    if (Array.isArray(_value)) {
      return _value || [];
    }
    return [];
  }
}
